<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-fade-transition duration="5000">
        <v-btn
          text
          v-on="on"
          :to="to"
          :disabled="disabled"
          v-show="show"
          @click="$emit('click')"
        >
          <v-icon> {{ icon }} </v-icon>
        </v-btn>
      </v-fade-transition>
    </template>
    <span>{{ tooltipText  }}</span>
  </v-tooltip>
</template>

<script>
export default {
  Name: 'AppBarItem',

  props: {
    to: String,
    icon: String,
    tooltipText: String,
    show: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
